import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/not-found")({
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center">
        <h1 className="font-serif text-6xl font-bold text-ink-primary">404</h1>
        <p className="mt-4 text-lede text-ink-secondary">
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-card bg-ink-primary px-6 py-3 text-ui font-medium text-surface-card transition hover:bg-ink-info"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
